import { createSlice } from '@reduxjs/toolkit';
import { operationsNamesArray } from '../../src/constants/constants';
export const operationsSlice = createSlice({
  name: 'operations',
  initialState: {
    operationsNamesArray: operationsNamesArray
  },
  reducers: {
    pushAddOperation: (state, action) => {
      state.operationsNamesArray = action.payload;
    }
  }
});
export const {
  pushAddOperation
} = operationsSlice.actions;
export default operationsSlice.reducer;